import React from 'react';

const PricingCTA = ({ className = '' }) => (
  <div className={`flex justify-center mt-16 ${className}`}>
    <a
      href="https://calendly.com/drake-orchestraos"
      target="_blank"
      rel="noopener noreferrer"
      className="group relative inline-block overflow-hidden px-8 py-4 rounded-xl
        bg-white/5 backdrop-blur-sm
        border border-white/10
        transition-all duration-500 
        hover:border-white/20
        hover:bg-white/10"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent 
        transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000">
      </div>
      <div className="relative flex items-center space-x-2">
        <span className="text-lg font-light tracking-wider text-white">
          Request a demo
        </span>
        <span className="text-lg text-white">→</span>
      </div>
    </a>
  </div>
);

export default PricingCTA; 